import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Controls from "../components/FormsUI";
import { useAuth } from "../utility/auth";
import RoleMenuAccessController from "../controller/RoleMenuAccess.Controller.jsx";
import MasterController from "../controller/MastersController.jsx";
import CustomizedSnackbars from "../components/Alert";
import EditIcon from "@mui/icons-material/Edit";
import Load from "../components/FormsUI/Loader/index";
import DeleteIcon from "@mui/icons-material/Delete";
import "../css/style.css";
import { tokens } from "../theme";
import {
  Container,
  Grid,
  useTheme,
  Box,
  Stack,
  IconButton,
  Radio,
  FormControlLabel,
} from "@mui/material";
import ExceptionHandlerController from "../controller/ErrorLogsController";

const INITIAL_FORM_STATE = {
  roleName: "",
  roleId: "",
};

const FORM_VALIDATION = Yup.object().shape({
  roleName: Yup.string()
    .matches(/^[A-Za-z ]*$/, "Role name is not in correct format")
    .trim("No white space allowed")
    .strict(true)
    .min(3)
    .max(50, "Name should not be exceed 50 Character")
    .required("Role name is required"),
  roleId: Yup.string()
    .matches(/^[A-Za-z0-9 ]*$/, "Role Id is not in correct format")
    .trim("No white space allowed")
    .strict(true)
    .min(2)
    .max(50, "Role Id should not be exceed 50 Character")
    .optional(),
});
let requestType = "";
let roles = [];

const RoleMenuAccess = () => {
  const roleMenuAccessController = new RoleMenuAccessController();
  const exceptionHandlerController = new ExceptionHandlerController();
  const masterController = new MasterController();
  const auth = useAuth();
  const user = auth.decoder(sessionStorage.getItem("user"));
  const { data, token } = user;
  const { userid: userId, tenantid: tenantId } = data.UserInfo;
  const [loader, setLoader] = useState(false); //set false
  const [updatedValues, setUpdatedValues] = useState(INITIAL_FORM_STATE);
  const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
  const [popup, setPopUp] = useState(false);
  const [allRoles, setAllRoles] = useState([]);
  const [menus, setMenus] = useState([]);
  const [selectedMenus, setSelectedMenus] = useState({});
  const [ddRoles, setDDRoles] = useState([]);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const showAlert = (type, msg) => {
    const notify = { ...alert };
    notify.counter = notify.counter + 1;
    notify.type = type;
    notify.msg = msg;
    setAlert(notify);
  };

  const fetchRoles = async () => {
    setLoader(true);
    try {
      const result = await roleMenuAccessController.GetRoles(tenantId, token);
      setAllRoles(result?.data?.body || []);
      setDDRoles(result?.data?.body?.map(role => ({
        label: role.roleName,
        value: role.id,  // or role.roleId if you want
        ...role
      })))
      //
    } catch (error) {
      // handleException(error, "Fetching all roles");
    } finally {
      setLoader(false);
    }
  };

  const fetchMasterMenus = async () => {
    try {
      const params = { type: "Menus" };
      const result = await masterController.GetMenus(params, token); // replace with actual method
      if (result?.status === 200) {
        // debugger;
        const menusList = result?.data?.body?.map(menu => ({
          _id: menu.menuId,
          menuName: menu?.menuName,
          submenus: (menu?.subMenus || []).map(sub => ({
            subMenuId: sub?._id,
            subMenuName: sub?.subMenuName
          }))
        }));
        setMenus(menusList);
      }
    } catch (error) {
      console.error("Failed to fetch master menus:", error);
    }
  };

  useEffect(() => {
    fetchRoles();
    fetchMasterMenus();
  }, []);

  const handleMenuChange = (menuId, submenus) => {
    setSelectedMenus(prev => {
      const updated = { ...prev };
      const isSelected = updated[menuId]?.checked;

      if (isSelected) {
        delete updated[menuId];
      } else {
        updated[menuId] = {
          checked: true,
          submenus: submenus.reduce((acc, sub) => {
            acc[sub.subMenuId] = true;
            return acc;
          }, {}),
        };
      }

      return updated;
    });
  };

  const handleSubMenuChange = (menuId, subMenuId) => {
    setSelectedMenus(prev => {
      const updated = { ...prev };
      if (!updated[menuId]) return prev;

      updated[menuId].submenus[subMenuId] = !updated[menuId].submenus[subMenuId];
      return updated;
    });
  };

  const columns = [
    {
      headerName: "ID",
      field: "id",
      hide: true,
      filterable: false,
      width: 210,
    },
    { headerName: "Role Name", field: "roleName", width: 210 },
    {
      field: "action",
      headerName: "Action",
      width: 210,
      sortable: false,
      filterable: false,
      disableExport: true,
      disableClickEventBubbling: true,

      renderCell: (params) => {
        const onClick = (e, type) => {
          let caughtError;
          try {
            setAlert({ counter: 0, type: "", msg: "" });
            const currentRow = params?.row;
            // debugger;
            if (type === "Edit") {
              setSelectedMenus({});
              // Assuming updatedValues is for form values; you can set it accordingly if needed
              setUpdatedValues(prev => ({
                ...prev,
                roleId: currentRow?.id || "",
                roleName: currentRow?.roleName || "",
              }));
              roleMenuAccessController.GetRoleMapped(params?.id, token).then((result) => {
                setLoader(() => false);
                if (result?.status === 200) {
                  const mappedAccess = result?.data?.body?.access || []; // assuming this contains [{menuId, subMenuId}, ...]

                  // Build selectedMenus object from mappedAccess
                  const selectedMenusFromResponse = {};

                  mappedAccess.forEach(({ menuId, subMenus }) => {
                    selectedMenusFromResponse[menuId] = {
                      checked: true,
                      submenus: {},
                    };

                    if (Array.isArray(subMenus)) {
                      subMenus.forEach((subMenuId) => {
                        selectedMenusFromResponse[menuId].submenus[subMenuId] = true;
                      });
                    }
                  });

                  // Set the menus and selectedMenus
                  setSelectedMenus(selectedMenusFromResponse);

                  // // Assuming updatedValues is for form values; you can set it accordingly if needed
                  // setUpdatedValues(prev => ({
                  //   ...prev,
                  //   roleId: result?.data?.body?.roleId || "",
                  //   roleName: result?.data?.body?.roleName || "",
                  // }));
                }
                handleData();
              })
            } else {
              if (type === "Delete") {
                roleMenuAccessController.Delete(currentRow?.id, token).then((response) => {
                  if (response.status === 200) {
                    showAlert("success", "Deleted successfully");
                    // setAllUsers((i) => {
                    //   return allUsers.filter(
                    //     (item) => item?.id !== currentRow.id
                    //   );
                    // });
                    fetchRoles();
                  } else if (response.data.status === 204) {
                    showAlert("error", response.data.message);
                  }
                  else if (response?.status === 500) {
                    showAlert("error", response?.response?.data?.message);
                  }
                })
              }
            }

          } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = { logData, module: "Role master onClick(Edit) method" };
            exceptionHandlerController.HandleException(logError);
          }
        };

        return (
          <Stack direction="row" spacing={2}>
            <>
              <IconButton onClick={(e) => onClick(e, "Edit")}>
                <EditIcon type="button" color="primary" id="Edit" />
              </IconButton>
              {/* <IconButton>
                <DeleteIcon
                  type="button"
                  color="secondary"
                  id="Delete"
                  onClick={(e) => onClick(e, "Delete")}
                />
              </IconButton> */}
            </>
          </Stack>
        );
      },
    },
  ];

  const handlePopup = (value) => setPopUp(() => value);
  const handleData = () => setPopUp(() => true);
  if (loader) return <Load />;

  const cleanSubmenus = (menus) => {
    return Object.keys(menus).reduce((acc, menuId) => {
      const menu = menus[menuId];
      if (menu.submenus && Object.keys(menu.submenus).length > 0) {
        acc[menuId] = { checked: menu.checked, submenus: menu.submenus };
      } else {
        acc[menuId] = { checked: menu.checked };
      }
      return acc;
    }, {});
  };

  const submitValues = (values) => {
    // debugger;
    values.tenantId = tenantId;// chaeck if got error
    delete values?.id
    delete values?.roledId
    delete values?.roleName

    let submitData = {};
    if (requestType === "Edit") {
      submitData.tenantId = values?.id; // chaeck if got error
      roleMenuAccessController
        .Update(values, token)
        .then((response) => {
          if (response.status === 200) {
            showAlert("success", response?.data?.message);
            handlePopup(false);
            setTimeout(
              () => setAlert({ counter: 0, type: "", msg: "" }),
              10000
            );
            // getAllUsers();
          } else {
            if (response?.data?.status === 204)
              showAlert("error", response?.data?.message);
            else if (response?.response?.status === 409)
              showAlert("error", response?.response?.data?.message);
            else if (response?.status === 500)
              showAlert("error", response?.response?.data?.message);
            setTimeout(
              () => setAlert({ counter: 0, type: "", msg: "" }),
              10000
            );
          }
        })
        .catch((error) => {
          showAlert("error", "Oops something went wrong.");
          setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
        });
    } else {
      values.selectedMenus = cleanSubmenus(values.selectedMenus);
      roleMenuAccessController
        .Create(values, token)
        .then((response) => {
          if (response?.status === 201) {
            handlePopup(false);
            showAlert("success", response?.data?.message);
            setTimeout(
              () => setAlert({ counter: 0, type: "", msg: "" }),
              10000
            );
            fetchRoles();
          } else if (response?.response?.status === 500) {
            showAlert("error", response?.response?.data?.message);
          }
          else if (response?.response?.status === 409) {
            showAlert("error", response?.response?.data?.message);
          }
          setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
        })
        .catch((error) => {
          showAlert("error", "Oops something went wrong.");
          setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
        });
    }
  };

  return (
    <>
      <Box
        sx={{
          "& .formBg": {
            border: `1px solid ${colors.grey[900]}`,
            background: `${colors.primary[400]}`,
          },
          "& li.MuiBreadcrumbs-li h6": { color: `${colors.primary[200]}` },
          "& .MuiGrid-root.Mui-heading h2": {
            color: `${colors.primary[200]} !important`,
          },
        }}
      >
        <Grid container>
          <Grid className="breadcrumb-section">
            <Grid className="breadcrumb-container">
              <Grid className="Mui-li">
                <nav className="Mui-nav" aria-label="breadcrumb">
                  <ol className="">
                    <li className="MuiBreadcrumbs-li">
                      <h6 className="breadsub">Settings</h6>
                    </li>
                    <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                      /
                    </li>
                    <li className="MuiBreadcrumbs-li">
                      <h6>Role Menu Access</h6>
                    </li>
                  </ol>
                </nav>
              </Grid>
            </Grid>
          </Grid>
          {/* <Grid item xs={12} md={12} className="adduser">
            <Controls.ActionButton onClick={() => AddUser()}>
              <span>Add New</span>
            </Controls.ActionButton>
          </Grid> */}
          <Grid item xs={12} className="formBg">
            <Container maxWidth="md" className="formClwidth">
              <div>
                <Controls.Grid
                  columns={columns}
                  data={allRoles}
                  fileName={"Users"}
                />
                {popup && (
                  <Controls.Popup
                    title="Set menu and sub-menu access for Roles"
                    openPopup={popup}
                    setOpenPopup={handlePopup}
                  >
                    <Formik
                      enableReinitialize
                      initialValues={{
                        ...(updatedValues || INITIAL_FORM_STATE),
                      }}
                      validationSchema={FORM_VALIDATION}
                      onSubmit={(values) => {
                        values.selectedMenus = selectedMenus;
                        submitValues(values)
                      }}
                    >
                      {({ values, setFieldValue }) => (
                        <Form>
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                              <Controls.AutoComplete
                                disabled={true}
                                name="roleId"
                                label="Select Role"
                                options={ddRoles}
                                value={ddRoles.find(item => item.value === values.roleId) || null}
                                onChange={(e, selected) =>
                                  setFieldValue("roleId", selected?.value || "")
                                }
                              />
                            </Grid>

                            {/* begin */}
                            <Grid item xs={12}>
                              <Box sx={{ mt: 2 }}>
                                <h4>Menu Access</h4>
                                <Grid container spacing={2}>
                                  {menus?.map((menu) => (
                                    <Grid item xs={12} sm={6} md={6} key={menu._id}>
                                      <Box
                                        sx={{
                                          border: `1px solid ${colors.grey[700]}`,
                                          borderRadius: "6px",
                                          padding: "10px",
                                          backgroundColor: colors.grey[900],
                                        }}
                                      >
                                        <FormControlLabel
                                          control={
                                            <input
                                              type="checkbox"
                                              checked={!!selectedMenus[menu._id]?.checked}
                                              onChange={() => handleMenuChange(menu._id, menu.submenus)}
                                              style={{ marginRight: '10px' }}
                                            />
                                          }
                                          label={<strong>{menu.menuName}</strong>}
                                        />

                                        {selectedMenus[menu._id]?.checked && menu.submenus?.length > 0 && (
                                          <Box sx={{ mt: 1, ml: 3 }}>
                                            {menu.submenus.map((sub) => (
                                              <FormControlLabel
                                                key={sub._id}
                                                control={
                                                  <input
                                                    type="checkbox"
                                                    checked={!!selectedMenus[menu._id]?.submenus?.[sub.subMenuId]}
                                                    onChange={() => handleSubMenuChange(menu._id, sub.subMenuId)}
                                                    style={{ marginRight: '8px' }}
                                                  />
                                                }
                                                label={sub.subMenuName}
                                                sx={{ display: "block", mb: 1 }}
                                              />
                                            ))}
                                          </Box>
                                        )}
                                      </Box>
                                    </Grid>
                                  ))}
                                </Grid>
                              </Box>
                            </Grid>

                            {/* end */}

                            <Grid item xs={12} md={6} className="marginAuto">
                            </Grid>
                            <Grid item xs={4} md={2} className="marginAuto">
                              <Controls.Button>Submit</Controls.Button>
                            </Grid>
                          </Grid>
                        </Form>
                      )}
                    </Formik>
                  </Controls.Popup>
                )}
              </div>
            </Container>
          </Grid>
          {alert?.counter > 0 && (
            <CustomizedSnackbars
              status={alert?.counter}
              msg={alert?.msg}
              type={alert?.type}
            />
          )}
        </Grid>
      </Box>
    </>
  );
};

export default RoleMenuAccess;